import { useMediaQuery } from "@material-ui/core";

export const IsScreenSizeSmall = theme => {
  return useMediaQuery(theme => theme.breakpoints.down("sm"));
};
